import React, { useContext } from 'react';
import { redirectIFrame } from '../../../helpers/iframeHelpers';
import API from '../../../constants/api';
import localization from '../../../constants/localization';

const EditGroupUsersInGroup = ({ usersInGroup }) => {

  const LS = useContext(localization);
  const handleUsers = (users) =>
    Object.entries(users).map(([id, name]) => (
      <tr key={id}>
        <td>
          <a
            style={{ cursor: 'pointer' }}
            onClick={() =>
              redirectIFrame(
                `${API.DAM.MANAGE_GROUPS}?action=manageUsersReact&id=${id}`
              )
            }
          >
            {name}
          </a>
        </td>
      </tr>
    ));
  return (
    <table>
      {Object.keys(usersInGroup).length !== 0 ? (
        handleUsers(usersInGroup)
      ) : (
        <tr>{LS.manageGroups.noUsers}</tr>
      )}
    </table>
  );
};

export default EditGroupUsersInGroup;
